// Solution 1: Convert to a custom hook
import { buildBreadcrumbUrl } from '@root/hooks/breadcrumbs/useBreadcrumbs';
import { useHistory } from 'react-router';
import { useCallback } from 'react';

const useRedirectWithParams = () => {
  const history = useHistory();

  const redirectWithParams = useCallback(
    args => {
      const { url, path, breadcrumbs, params } = args;
      
      // Support both 'url' and 'path' parameter names
      let targetPath = url || path;
      
      // If params exist, append them as query string
      if (params && Object.keys(params).length > 0) {
        const queryString = new URLSearchParams(params).toString();
        targetPath = `${targetPath}?${queryString}`;
      }

      history.push(
        buildBreadcrumbUrl({
          path: targetPath,
          breadcrumbs: breadcrumbs,
        }),
      );
    },
    [history],
  );

  return redirectWithParams;
};

export default useRedirectWithParams;

// Usage in a component:
// const Component = () => {
//   const redirectWithParams = useRedirectWithParams();
//
//   const handleClick = () => {
//     redirectWithParams({ url: '/some-path', breadcrumbs: [...] });
//   };
//
//   return <button onClick={handleClick}>Navigate</button>;
// };
